<script>
import NavigationHeader from '../NavigationHeader.vue';

import CallsOverviewService from '@/services/CallsOverviewService';

export default {
    name: 'CallsOverview',
    components: { NavigationHeader },
    data() {
        return {
            callsLists: []
        };
    },
    created() {
        CallsOverviewService.getCallsOverview()
        .then((responseCallsOverview) => {
            this.callsLists = responseCallsOverview.data;
            if (this.callsLists) {
                for (const entry of this.callsLists) {
                    entry.start = this.formatTimestamps(entry.start);
                    entry.duration = this.formatDuration(entry.duration);
                }
            }
        });
    },
    methods: {
        formatTimestamps(timestamp) {
            const timestampArray = timestamp.split(' ', 2);
            const dateArray = timestampArray[0].split('-', 3);
            return dateArray[2] + '.' + dateArray[1] + '.' + dateArray[0] + ' ' + timestampArray[1];
        },
        formatDuration(duration) {
            const durationArray = duration.split(':', 4);
            return durationArray[1] + ':' + durationArray[2] + ':' + durationArray[3];
        },
    },
};
</script>

<template>
    <div class="container">
        <div id="calls-overview">
            <NavigationHeader route="/" navigationText="zurück zum Dashboard" title="Gesprächsübersicht" />
            <div class="wrapper">
                <p>Hier findest Du die Details über die ausgehenden Gespräche der letzten 30 Tage.</p>
                    <table class="table">
                        <thead>
                            <tr>
                                <th >Zielrufnummer</th>
                                <th>Datum</th>
                                <th>Dauer</th>
                                <th ></th>
                            </tr>
                        </thead>
                        <tbody v-if="callsLists">
                            <tr v-for="call in callsLists" :key="call.id">
                                <td>{{call.target}}</td>
                                <td>{{call.start}}</td>
                                <td>{{call.duration}}</td>
                                <td>&nbsp;</td>
                            </tr>
                        </tbody>
                    </table>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

#calls-overview {
    .table {
        border-spacing: 0;
        width: 100%;
        margin-top: 50px;
        thead {
            tr th {
                color: #ffffff;
                font-weight: bold;
                font-size: 18px;
                background-color: #b8b8b8;
                padding: 16px;
                text-align: left;
            }
        }
        tbody {
            tr {
                td {
                    padding: 24px 16px;
                    &:first-child {
                        font-weight: bold;
                    }
                    &:last-child {
                        width: 30%;
                    }
                }

                &:nth-child(odd) {
                    background-color: #fff;
                }
            }
        }
    }
}
</style>
